export enum WalletProduct {
  EUA = 'EUA',
  EUR = 'EUR',
}
